
import VRadio from '~/components/ui/VRadio'
import VButton from '~/components/ui/VButton'
import VFormGroup from '~/components/ui/VFormGroup'
import CoworkingBookingLayout from '~/components/modals/booking/CoworkingBookingLayout'
import { mapActions, mapState } from 'vuex'

export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        buttons: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapState('booking', [
            'bookingData'
        ])
    },
    methods: {
        ...mapActions('booking', [
            'changeData'
        ]),
        changeValue(field, value) {
            this.changeData({
                field: field,
                value: value
            })
            if (field === 'duration') {
                let price = ''
                switch (this.bookingData.duration) {
                    case 'day':
                        price = '10$'
                        break;
                    case 'week':
                        price = '40$'
                        break;
                    case 'month':
                        price = '300$'
                        break;
                    default:
                        price = '10$'
                        break;
                }
                this.changeData({
                    field: 'price',
                    value: price
                })
            }
        }
    },
    components: {
        VRadio,
        VButton,
        VFormGroup,
        CoworkingBookingLayout
    }
}
